import { useContext, useEffect, useState } from "react";
import { SearchContext, SearchContextType } from "../provider/SearchProvider";
import Pagination from "../../Common/Pagination/Pagination";
import { getSearchMessage } from "../../Helpers/utils";

export type SearchResultsModel = {
  resultMessage: string,
  noResultMessage: string
}

export default function SearchResults({ resultMessage, noResultMessage }: SearchResultsModel) {
  const [message, setMessage] = useState<string>('');
  const { searchTerm, results, totalRecords, currentPage, pageSize, loadItems } = useContext(SearchContext) as SearchContextType;

  useEffect(() => {
    if (results && results.length > 0 && searchTerm.length > 0) {
      setMessage(getSearchMessage(searchTerm, totalRecords, noResultMessage, resultMessage));
    } else {
      setMessage('');
    }
  }, [results])

  return (
    <div className="search-section">
      { message.length > 0 && 
        <div dangerouslySetInnerHTML={ { __html: message}} >
        </div>
      }     
      { totalRecords > 0 && results.map((result, index) => (
        <div className="result" key={`search-${index}`}>
          <a href={result.url}>
            <h5>{result.name}</h5>
            {result.summary?.length > 0 && <p>{result.summary}</p>}
          </a>
        </div>
      )) }
      {<Pagination totalRecords={totalRecords} currentPage={currentPage} pageSize={pageSize} onPageChange={loadItems} />}
    </div>
  )
}